import React from 'react'
import {Image} from "@chakra-ui/react"

const PersonIcon = (w,h) => {
  return (
    //   <>
    <img 
    width={`20px`} height={`auto`}
    src={'./assets/person-solid.svg'} 
    ></img>
    // </>
  )
}

export default PersonIcon